<template>
    <b-row class="classification mt-2">
        <b-col
            v-if="!!classification.category"
            cols="12"
        >
            <b-alert variant="warning"
                     class="toxicity-alert"
                     show
            >
                <h6 class="font-weight-bold">
                    <i class="fa fa-exclamation-triangle warning-icon"></i>
                    <span class="alert-title">
                        {{
                            classification.danger.name
                        }}
                    </span>
                </h6>
                <span class="font-weight-bold">CLASE:</span>
                {{ classification.danger_class.name }}
                <br>
                <span class="font-weight-bold">CATEGORÍA:</span>
                {{ classification.category }}
                <br>
                <span class="font-weight-bold"
                      v-if="classification.sub_category"
                >
                    SUBCATEGORÍA:
                </span>
                <span v-if="classification.sub_category">
                    {{ classification.sub_category.toUpperCase() }}
                    <br>
                </span>
                <span class="font-weight-bold">CÓDIGO E INDICACIÓN DE PELIGRO:</span>
                <div v-for="sga_category in classification.sga_categories"
                     class="pl-4"
                >
                    <b-badge variant="warning">
                        {{ sga_category.category.codigo }}
                    </b-badge>
                    {{ sga_category.category.codigos.descripcion.toUpperCase() }}
                </div>
                <div v-if="!classification.sga_categories.length"
                     class="pl-4"
                >
                    SIN INDICACIONES DE PELIGRO
                </div>
            </b-alert>
        </b-col>
        <b-col v-else-if="!!classification"
               cols="12"
        >
            <b-alert variant="success"
                     show
                     class="no-classification"
            >
                <h6 class="font-weight-bold"
                    v-if="!!classification.danger"
                >
                    <i class="fa fa-check success-icon"></i>
                    <span class="success-title">{{
                            classification.danger.name
                        }}
                    </span>
                </h6>
                <span v-if="classification.justification">
                    {{ classification.justification }}
                </span>
                <span v-else>
                    NO SE CUMPLEN LOS CRITERIOS DE CLASIFICACIÓN DEL SGA, PARA ESTA CLASE DE PELIGRO
                </span>
            </b-alert>
        </b-col>
    </b-row>
</template>

<script>

export default {
    name: 'classification',
    props: {
        classification: {
            required: true
        },
        questions_index: {
            required: false,
            default: null
        }
    }
};
</script>

<style lang="scss">

.classification {
    .toxicity-alert {
        background-color: #fefaf3;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-bottom: 20px;
        border-left: 4px solid #f0b429 !important;
    }

    .no-classification {
        background-color: #63e6911a;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-bottom: 20px;
        border-left: 4px solid #16a90b !important;
    }

    .warning-icon {
        color: #d97706;
        font-size: 22px;
        margin-right: 12px;
    }

    .success-icon {
        color: #098a01;
        font-size: 22px;
        margin-right: 12px;
    }

    .alert-title {
        font-weight: 700;
        color: #d97706;
        font-size: 16px;
        letter-spacing: 0.5px;
    }

    .success-title {
        font-weight: 700;
        color: #098a01;
        font-size: 16px;
        letter-spacing: 0.5px;
    }
}
</style>
